import { PayloadProps, PutPayloadProps } from "src/models/service.models";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function addJobSkill(data: PayloadProps) {
  return await apiCall.post(
    API_URL.CATEGORY_MANAGEMENT.JOB_SKILL.ADD_JOB_SKILL,
    data
  );
}
export async function deleteJobSkill(params: string) {
  return await apiCall.remove(
    API_URL.CATEGORY_MANAGEMENT.JOB_SKILL.DELETE_JOB_SKILL + params
  );
}

export async function getJobskill() {
  return await apiCall.get(API_URL.CATEGORY_MANAGEMENT.JOB_SKILL.GET_JOB_SKILL);
}

export async function updateJobSkill(params: string, data: PutPayloadProps) {
  return await apiCall.put(
    API_URL.CATEGORY_MANAGEMENT.JOB_SKILL.UPDATE_JOB_SKILL + params,
    data
  );
}
